import { useState } from "react"

import { Spinner } from "@/components/ui/Spinner"

// <object> but with a loading indicator.
export function ObjectLoader({
  type,
  data,
  width,
  height,
  className,
}: {
  type: string
  data: string
  width: string
  height: string
  className?: string
}) {
  const [loading, setLoading] = useState(true)
  return (
    <>
      {loading && <Spinner />}
      <object
        className={className}
        width={width}
        height={height}
        type={type}
        data={data}
        onLoad={() => setLoading(false)}
      />
    </>
  )
}
